/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SearchDeals200ResponseInnerCardTransactionEvidenceListInner } from './search-deals200-response-inner-card-transaction-evidence-list-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SearchDeals200ResponseInnerIntegratedBy } from './search-deals200-response-inner-integrated-by';
// May contain unused imports in some cases
// @ts-ignore
import { SearchDeals200ResponseInnerInvoiceIssuer } from './search-deals200-response-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { SearchDeals200ResponseInnerJournalEntriesInner } from './search-deals200-response-inner-journal-entries-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SearchDeals200ResponseInnerJournalizedBy } from './search-deals200-response-inner-journalized-by';

/**
 * 
 * @export
 * @interface SearchDeals200ResponseInner
 */
export interface SearchDeals200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDeals200ResponseInner
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDeals200ResponseInner
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'status': SearchDeals200ResponseInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SearchDeals200ResponseInnerJournalizedBy}
     * @memberof SearchDeals200ResponseInner
     */
    'journalizedBy': SearchDeals200ResponseInnerJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SearchDeals200ResponseInnerIntegratedBy}
     * @memberof SearchDeals200ResponseInner
     */
    'integratedBy': SearchDeals200ResponseInnerIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDeals200ResponseInner
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SearchDeals200ResponseInnerJournalEntriesInner>}
     * @memberof SearchDeals200ResponseInner
     */
    'journalEntries': Array<SearchDeals200ResponseInnerJournalEntriesInner>;
    /**
     * 
     * @type {Array<SearchDeals200ResponseInnerCardTransactionEvidenceListInner>}
     * @memberof SearchDeals200ResponseInner
     */
    'cardTransactionEvidenceList': Array<SearchDeals200ResponseInnerCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SearchDeals200ResponseInner
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDeals200ResponseInner
     */
    'canSync': boolean;
    /**
     * 
     * @type {SearchDeals200ResponseInnerInvoiceIssuer}
     * @memberof SearchDeals200ResponseInner
     */
    'invoiceIssuer': SearchDeals200ResponseInnerInvoiceIssuer | null;
}

export const SearchDeals200ResponseInnerStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SearchDeals200ResponseInnerStatusEnum = typeof SearchDeals200ResponseInnerStatusEnum[keyof typeof SearchDeals200ResponseInnerStatusEnum];


